import React, { Component } from "react";
import PropTypes from 'prop-types';
import {answerBubbleStyle, answerBubbleStyleMobile} from '../../utils/styles';

class ProblemResults extends Component {
  constructor(props) {
    super(props);

    this.state = {
        selectResultText: '',
    }
  }


  componentWillMount() {
      
  }

  componentDidMount(){
    try {
        let previousStep = this.props.previousStep;
        if(!!previousStep){
          let value ='';
          if(previousStep['value']){
            value = previousStep['value']['label'] ? previousStep['value']['label']: previousStep['value'];
            this.setState({
              selectResultText: value
            });
            this.props.step.value = previousStep['value']['value'];
          }
           
        }
      } catch (error) {
          console.log(error);
      }

    try {
        if(this.props.helloTextStorageKey){
            let value = localStorage.getItem(this.props.helloTextStorageKey);
    
            if(this.props.helloTextStorageKey == "SQ_firstname"){
                value+= " "+localStorage.getItem("SQ_lastname");
            }
            this.setState({
                selectResultText: value
            });
        }
    } catch (error) {}

      if(localStorage.getItem("auth_token")){
        try {
          let step = this.props.step;
          
          localStorage.setItem("doneQuizStepId",step.id);
        } catch (error) {
          console.error(error);
        }
      }

  }



  render() {
    return (
        <div style={ document.documentElement.clientWidth <= 812? answerBubbleStyleMobile : answerBubbleStyle}>
            {this.state.selectResultText}
        </div>
      );
  }
}

ProblemResults.propTypes = {
  steps: PropTypes.object,
};

ProblemResults.defaultProps = {
  steps: undefined,
};

export default ProblemResults;



// WEBPACK FOOTER //
// ./src/views/onboardingAA/ProblemResults.js